/** Shape returned by `GET keys/hyperpay`. */
export interface HyperPayKeysRecord {
  url?: string;
  token?: string;
  entityId?: string;
  entityIdMada?: string;
}

/** Result codes HyperPay uses for a settled (or reviewable-but-accepted) payment. */
const SUCCESS_CODES = [
  "000.100.110",
  "000.100.112",
  "000.000.000",
  "000.200.000",
];

export function isHyperPaySuccessResult(
  result: { code?: string; description?: string } | null | undefined
): boolean {
  if (!result) return false;
  if (result.code && SUCCESS_CODES.includes(result.code)) return true;
  return Boolean(
    result.description?.toLowerCase().includes("successfully processed")
  );
}

/** Base URL for HyperPay API + widget script (no trailing slash). */
export function getHyperPayBaseUrl(
  keys: HyperPayKeysRecord | null | undefined
): string | null {
  const raw = keys?.url;
  if (raw == null || typeof raw !== "string") return null;
  const trimmed = raw.trim().replace(/\/+$/, "");
  return trimmed || null;
}

/**
 * HyperPay's REST API has no CORS, so browser calls go through our own
 * origin (`/hyperpay/test|live`, proxied by setupProxy.js in dev and nginx.conf in Docker).
 * The widget <script> still loads straight from `getHyperPayBaseUrl`.
 */
export function hyperPayApiBase(baseUrl: string): string {
  return baseUrl.includes("eu-test.") ? "/hyperpay/test/v1" : "/hyperpay/live/v1";
}
